import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-text-default px-6 py-1 text-sm" }
const _hoisted_2 = { class: "flex flex-row px-6 py-6" }

import useTranslate from '@/utilities/composables/useTranslate';
import PopupHeader from '@/components/elements/PopupHeader';
import ButtonCustom from '@/components/elements/ButtonCustom';
import constants from '@/utilities/constants';
import useCurrentRole from '@/utilities/composables/useCurrentRole';
import { onMounted, onUnmounted, computed } from 'vue';
import { TeamMemberRole } from '@superthread-com/api';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradePlanPopUp',
  emits: ['closePopup'],
  setup(__props) {

const { translate } = useTranslate();
const store = useStore();
const router = useRouter();
const { isElevated } = useCurrentRole();



onMounted(() => {
  window.addEventListener('keyup', keypressHandler);
});

onUnmounted(() => {
  window.removeEventListener('keyup', keypressHandler);
});

function keypressHandler(e) {
  if (e.code === 'Enter') {
    routeToUpgradePlan();
  }
  if (e.code === 'Escape') {
    e.stopPropagation();
    hidePopUp();
  }
}

function hidePopUp() {
  store.dispatch('setShowUpgradePlanPopup', null);
}

const currentRole = computed(() => {
  return store.getters.getCurrentRole;
});

const userHasAccessToBilling = computed(() => {
  return [TeamMemberRole.Owner, TeamMemberRole.Admin].includes(currentRole.value);
});

const owner = computed(() => {
  return store.getters.getMemberById(store.getters.getWorkspaceOwner?.id);
});

function routeToUpgradePlan() {
  if (!userHasAccessToBilling.value) return;
  router.push({
    name: constants.routeNames.billing,
  });
  store.dispatch('setShowUpgradePlanPopup', null);
  if (store.getters.getAddMemberPopupIsOn) {
    store.dispatch('setAddMemberPopup', false);
  }
}

const popupContent = computed(() => {
  const { featureFlagIds: ffIds } = constants;
  const contentMap = {
    [ffIds.privateSpace]: {
      title: 'upgradePrivateSpaceTitle',
      description: 'upgradePrivateSpaceDescription',
    },
    [ffIds.userPermissions]: {
      title: 'upgradeUserRolesTitle',
      description: 'upgradeUserRolesDescription',
    },
    [ffIds.publicPageIndexing]: {
      title: 'upgradePublicPageIndexingTitle',
      description: 'upgradePublicPageIndexingDescription',
    },
    [ffIds.timelineLayout]: {
      title: 'upgradePlan',
      description: 'timelineLayoutDescription',
    },
    [ffIds.calendarLayout]: {
      title: 'upgradePlan',
      description: 'calendarLayoutDescription',
    },
    [ffIds.views]: {
      title: 'upgradePlan',
      description: 'upgradeViewsDescription',
    },
    [ffIds.cardAndPageTemplates]: {
      title: 'upgradePlan',
      description: 'upgradeTemplatesDescription',
    },
    [ffIds.roadmapAndProjects]: {
      title: 'upgradePlan',
      description: 'upgradeRoadmapAndProjectsDescription',
    },
  };
  return contentMap[store.getters.getShowUpgradePlanPopup] || { title: '', description: '' };
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal upgrade-plan-modal",
    onClick: hidePopUp,
    onBlur: hidePopUp
  }, [
    _createElementVNode("div", {
      class: "upgrade-plan-popup",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode(_unref(PopupHeader), {
        title: _unref(translate)(popupContent.value.title),
        onClose: hidePopUp
      }, null, 8, ["title"]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(translate)(popupContent.value.description)), 1),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ButtonCustom), {
          class: "text-sm font-normal rounded border-important-border flex-grow",
          text: _unref(translate)('cancel'),
          type: 'popup-button-wrap important',
          onClick: hidePopUp
        }, null, 8, ["text"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _withDirectives(_createVNode(_unref(ButtonCustom), {
          class: "text-sm font-normal rounded border-important-border flex-grow ml-1",
          text: _unref(translate)('upgradePlan'),
          type: 'popup-button-wrap attention',
          onClick: routeToUpgradePlan
        }, null, 8, ["text"]), [
          [_directive_tooltip, {
            content: _unref(translate)('upgradePlanBadgeTooltip', { spaceOwner: owner.value?.display_name }),
            placement: 'top',
            onShow: () => !_ctx.isMobile && !_unref(isElevated),
          }]
        ])
      ])
    ])
  ], 32))
}
}

})